import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseValidationFrom} from '../base-validation.form';
import {
    AmountControl,
    BaseControl,
    DatepickerControl,
    Helper,
    RadioGroupControl,
    SelectControl
} from "appShared/classes";
import {ColorCodesEnum, ComponentTypesEnum} from "appShared/enums";
import {environment} from "appEnv/environment";
import * as moment from 'moment';
import {FundOrderTypesEnum} from "@spa/api";

export class FundOrderMatchingInventoryForm extends BaseValidationFrom<FundOrderMatchingInventoryControlsInterface> {
    initForm(): void {
        this.form = new FormGroup({});
        this.controls = FundOrderMatchingInventoryComponentControls();

        Object.keys(this.controls).forEach((key: string) => {
            const control = this.controls[key];
            this.form.addControl(control.name, new FormControl(control.value, control.validators));
        });
    }
}

export interface FundOrderMatchingInventoryControlsInterface {
    amount: AmountControl;
    product: SelectControl;
    price: AmountControl;
    interest: AmountControl;
    executionCreatedOnDate: DatepickerControl;
    executionCreatedOn: BaseControl;
    counterparty: SelectControl;
    orderType: RadioGroupControl;
}


export const FundOrderMatchingInventoryComponentControls = (): FundOrderMatchingInventoryControlsInterface => {
    return {
        product: new SelectControl({
            name: FundOrderMatchingInventoryProductSelector,
            value: null,
            placeholder: 'Product Name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        amount: new AmountControl({
            name: FundOrderMatchingInventoryAmountSelector,
            value: null,
            placeholder: 'Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        price: new AmountControl({
            name: FundOrderMatchingInventoryPriceSelector,
            value: null,
            placeholder: 'Price',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null,
            isPercentage: true,
            fourDecimals: true
        }),
        interest: new AmountControl({
            name: FundOrderMatchingInventoryInterestSelector,
            value: null,
            placeholder: 'Accrued Interest',
            validators: [],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null,
            isPercentage: true
        }),
        executionCreatedOnDate: new DatepickerControl({
            name: FundOrderMatchingInventoryDateSelector,
            value: null,
            placeholder: 'Execution Date',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Datepicker,
            maxDate: moment(new Date()).format(environment.dateFormatLocalDate),
        }),
        executionCreatedOn: new BaseControl({
            name: FundOrderMatchingInventoryTimeSelector,
            value: null,
            placeholder: `Execution Time (${Helper.getTimeZone()})`,
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text,

            nonCapitalizedPlaceholder: true,
            floatingLabelNever: true,
            upperCaseValue: true
        }),
        counterparty: new SelectControl({
            name: FundOrderMatchingInventoryCounterpartySelector,
            value: null,
            placeholder: 'Counterparty',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
            isDynamic: true,
        }),
        orderType: new RadioGroupControl({
            name: FundOrderOrderTypeSelector,
            value: FundOrderTypesEnum.Buy,
            placeholder: 'Execution Type',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.RadioGroup,
            invalid: false,
            disabled: true,
            errors: [],
            options: [{
                label: 'Buy',
                value: FundOrderTypesEnum.Buy,
                color: ColorCodesEnum.Primary,
                checked: true,
                disabled: true
            }, {
                label: 'Sell',
                value: FundOrderTypesEnum.Sell,
                color: ColorCodesEnum.Primary,
                disabled: true
            }]
        }),
    };
};


export const FundOrderMatchingInventoryAmountSelector = 'fundOrderMatchingInventoryAmount';
export const FundOrderMatchingInventoryProductSelector = 'fundOrderMatchingInventoryProducts';
export const FundOrderMatchingInventoryPriceSelector = 'fundOrderMatchingInventoryPrice';
export const FundOrderMatchingInventoryInterestSelector = 'fundOrderMatchingInventoryInterest';
export const FundOrderMatchingInventoryDateSelector = 'fundOrderMatchingInventoryDate';
export const FundOrderMatchingInventoryTimeSelector = 'fundOrderMatchingInventoryTime';
export const FundOrderMatchingInventoryCounterpartySelector = 'fundOrderMatchingInventoryCounterparty';
export const FundOrderOrderTypeSelector = 'fundOrderMatchingInventoryOrderType';


